package org.braunequip.web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.rememberPageContext
import kotlinx.browser.document
import org.braunequip.web.util.Constants
import org.braunequip.web.util.Routes.Admin.FRONT_ASSET_ROUTE
import org.braunequip.web.util.Routes.Admin.FRONT_EMPLOYEE_ROUTE
import org.braunequip.web.util.Routes.Admin.FRONT_FORMS_ROUTE
import org.braunequip.web.util.Routes.Admin.FRONT_MAINTSCHEDULE_ROUTE
import org.braunequip.web.util.routeToAuthLogout
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLElement
import org.w3c.dom.asList

fun AdminNavbarBurgerListener() {
    val navBurgers = document.querySelectorAll(".navbar-burger")
        .asList()
        .filterIsInstance<HTMLElement>()

    navBurgers.forEach { burger ->
        burger.addEventListener("click", {
            val targetId = burger.getAttribute("data-target")
            val target = targetId?.let { document.getElementById(it) }
            if (target is HTMLElement) {
                burger.classList.toggle("is-active")
                target.classList.toggle("is-active")
            }
        })
    }
}

@Composable
fun AdminNavHeader(context: PageContext) {
    val context = rememberPageContext()

    LaunchedEffect(Unit) {
        AdminNavbarBurgerListener()
    }

    Nav(
        attrs = Modifier
            .fontFamily(Constants.FONT_FAMILY2)
            .classNames("navbar")
            .fillMaxWidth()
            .toAttrs()
    ) {

        //Brand Name
        Div(
            attrs = Modifier
                .padding(leftRight = 1.cssRem)
                .classNames("navbar-brand")
                .toAttrs()
        ) {
            H2(
                attrs = Modifier
                    .margin(0.px)
                    .fontSize(28.px)
                    .toAttrs()
            ) {
                Text("Braun Admin Dash")
            }

            A(
                attrs = Modifier
                    .classNames("navbar-burger")
                    .role("button")
                    .ariaLabel("menu")
                    .toAttrs {
                        attr("aria-expanded", "false")
                        attr("data-target", "navbarBasicExample")
                    }
            ) {
                Span(
                    attrs = Modifier
                        .toAttrs { attr("aria-hidden", "true") }
                )
                Span(
                    attrs = Modifier
                        .toAttrs { attr("aria-hidden", "true") }
                )
                Span(
                    attrs = Modifier
                        .toAttrs { attr("aria-hidden", "true") }
                )
                Span(
                    attrs = Modifier
                        .toAttrs { attr("aria-hidden", "true") }
                )
            }
        }

        //Menu Items
        Div(
            attrs = Modifier
                .classNames("navbar-menu")
                .id("navbarBasicExample")
                .toAttrs()
        ) {

            //Navbar Start Items
            Div(
                attrs = Modifier
                    .classNames("navbar-start")
                    .toAttrs()
            ) {
                A(
                    attrs = Modifier
                        .onClick {
                            context.router.navigateTo(FRONT_FORMS_ROUTE)
                        }
                        .classNames("navbar-item")
                        .toAttrs()
                ) {
                    Text("Forms")
                }

                A(
                    attrs = Modifier
                        .onClick {
                            context.router.navigateTo(FRONT_EMPLOYEE_ROUTE)
                        }
                        .classNames("navbar-item")
                        .toAttrs()
                ) {
                    Text("Employees")
                }

                A(
                    attrs = Modifier
                        .onClick {
                            context.router.navigateTo(FRONT_ASSET_ROUTE)
                        }
                        .classNames("navbar-item")
                        .toAttrs()
                ) {
                    Text("Assets")
                }

                A(
                    attrs = Modifier
                        .onClick {
                            context.router.navigateTo(FRONT_MAINTSCHEDULE_ROUTE)
                        }
                        .classNames("navbar-item")
                        .toAttrs()
                ) {
                    Text("Maint-Schedules")
                }
            }

            //Navbar End Items
            Div(
                attrs = Modifier
                    .classNames("navbar-end")
                    .toAttrs()
            ) {
                Div(
                    attrs = Modifier
                        .classNames("navbar-item")
                        .toAttrs()
                ) {
                    Div(
                        attrs = Modifier
                            .classNames("buttons")
                            .toAttrs()
                    ) {
                        Div(
                            attrs = Modifier
                                .onClick {
                                    routeToAuthLogout(context)
                                }
                                .classNames("button", "is-primary")
                                .color(Colors.White)
                                .toAttrs()
                        ) {
                            Text("Sign Out")
                        }
                    }
                }
            }
        }
    }
}